'use client';

import React from 'react';
import { Truck, CheckCircle } from 'lucide-react';

interface FreeShippingProgressBarProps {
  className?: string;
  compact?: boolean;
}

const FreeShippingProgressBar: React.FC<FreeShippingProgressBarProps> = ({
  className = '',
  compact = false
}) => {
  if (compact) {
    return (
      <div className={`bg-green-50 border border-green-200 rounded-lg p-3 ${className}`}>
        <div className="flex items-center gap-2">
          <Truck className="h-4 w-4 text-green-600" />
          <span className="text-sm text-green-700 font-medium flex items-center gap-1">
            <CheckCircle className="h-4 w-4" />
            FREE Shipping on Eligible Orders
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-green-50 border border-green-200 rounded-xl p-4 ${className}`}>
      <div className="flex items-center gap-2">
        <div className="p-2 rounded-full bg-green-100">
          <Truck className="h-5 w-5 text-green-600" />
        </div>
        <div className="flex items-center gap-1">
          <CheckCircle className="h-5 w-5 text-green-600" />
          <span className="font-semibold text-green-700">FREE Shipping on Eligible Orders</span>
        </div>
      </div>
    </div>
  );
};

export default FreeShippingProgressBar;
